export const address = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        masterdata:'Master Data',
        address_management:'Address Managem',
        add_address:'Add Address',
        add_address_information:'Add Address Information',
        edit_address:'Edit Address',
        cancel:'cancel',
        submit:'submit',
        state_col:"State",
        city_col:"City",
        pincode_col:"Pincode",
        address_information:'Address Information',
      
    },

    ar: {
        masterdata:'البيانات الرئيسية',
        address_management:'إدارة العناوين',
        add_address:'اضف عنوان',
        add_address_information:'أضف تفاصيل العنوان',
        edit_address:' تعديل العنوان',
        cancel:'إلغاء',
        submit:'إرسال',
        address_information:'تفاصيل العنوان',
        state_col:"حالة",
        city_col:"مدينة",
        pincode_col:"الرمز السري"
    },

}
   